"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicle = void 0;
const bodyType_1 = require("./bodyType");
const bodyTypeSearch_1 = require("./bodyTypeSearch");
const cabStyle_1 = require("./cabStyle");
const color_1 = require("./color");
const condition_1 = require("./condition");
const country_1 = require("./country");
const deal_1 = require("./deal");
const decodeMethod_1 = require("./decodeMethod");
const driveType_1 = require("./driveType");
const engineAspiration_1 = require("./engineAspiration");
const engineFuel_1 = require("./engineFuel");
const engineFuelInduction_1 = require("./engineFuelInduction");
const featureTag_1 = require("./featureTag");
const make_1 = require("./make");
const marketSegment_1 = require("./marketSegment");
const price_1 = require("./price");
const saleStatus_1 = require("./saleStatus");
const seats_1 = require("./seats");
const seller_1 = require("./seller");
const seoPopularCategory_1 = require("./seoPopularCategory");
const size_1 = require("./size");
const sortOption_1 = require("./sortOption");
const specification_1 = require("./specification");
const title_1 = require("./title");
const transmission_1 = require("./transmission");
const upholstery_1 = require("./upholstery");
const weightClass_1 = require("./weightClass");
const lkpMileage = [5000, 10000, 20000, 30000, 50000, 75000, 100000, 150000, 200000];
const lkpMpg = [10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 80, 100];
const lkpTowingCapacity = [2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 15000, 20000];
const lkpAcceleration = [2, 2.5, 3, 3.5, 4, 5, 6, 7, 8, 9, 10];
const lkpEngineCylinder = [0, 2, 3, 4, 5, 6, 8, 10, 12, 16];
const lkpHorsepower = [100, 150, 200, 250, 300, 350, 400, 500, 600, 700, 800, 900, 1000];
const lkpTorque = [100, 150, 200, 250, 300, 350, 400, 500, 600, 700, 800];
const lkpPowerToWeight = [4, 7, 10, 14];
const lkpBedLength = [40, 50, 60, 70, 80, 90];
const lkpLegRoomFront = [40, 42.5, 44.5];
const lkpLegRoomRear = [34, 37.5, 40.5];
const lkpElectricRange = [20, 40, 100, 200, 300, 400];
const lkpTransGear = [0, 1, 3, 4, 5, 6, 7, 8, 9, 10, 13, 18];
const lkpDoor = [1, 2, 3, 4];
const lkpSeat = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12];
exports.vehicle = {
    saleStatus: saleStatus_1.saleStatus,
    condition: condition_1.condition,
    getConditionByName: condition_1.getConditionByName,
    engineAspiration: engineAspiration_1.engineAspiration,
    getEngineAspirationName: engineAspiration_1.getEngineAspirationName,
    transmission: transmission_1.transmission,
    getTransmission: transmission_1.getTransmission,
    fuelType: engineFuel_1.fuelType,
    getFuelTypeName: engineFuel_1.getFuelTypeName,
    getFuelType: engineFuel_1.getFuelType,
    fuelInduction: engineFuelInduction_1.fuelInduction,
    getFuelInductionName: engineFuelInduction_1.getFuelInductionName,
    driveType: driveType_1.driveType,
    colorGroup: color_1.colorGroup,
    marketSegment: marketSegment_1.marketSegment,
    sellerType: seller_1.sellerType,
    titleType: title_1.titleType,
    featureTag: featureTag_1.featureTag,
    bodyType: bodyType_1.bodyType,
    bodyTypeSearch: bodyTypeSearch_1.bodyTypeSearch,
    size: size_1.size,
    weightClass: weightClass_1.weightClass,
    SortEnum: sortOption_1.SortEnum,
    sortOption: sortOption_1.sortOption,
    decodeMethodOption: decodeMethod_1.decodeMethodOption,
    specification: specification_1.specification,
    hdSpecification: specification_1.hdSpecification,
    country: country_1.country,
    popularMake: make_1.popularMake,
    exotic: make_1.exotic,
    luxury: make_1.luxury,
    sport: make_1.sport,
    upholstery: upholstery_1.upholstery,
    lkpPrice: price_1.lkpPrice,
    price: price_1.price,
    seats: seats_1.seats,
    deal: deal_1.deal,
    seoPopularCategory: seoPopularCategory_1.seoPopularCategory,
    cabStyle: cabStyle_1.cabStyle,
    lkpMileage,
    lkpMpg,
    lkpTowingCapacity,
    lkpAcceleration,
    lkpHorsepower,
    lkpTorque,
    lkpPowerToWeight,
    lkpBedLength,
    lkpLegRoomFront,
    lkpLegRoomRear,
    lkpElectricRange,
    lkpTransGear,
    lkpDoor,
    lkpSeat,
    lkpEngineCylinder,
};
